import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot } from '@angular/router';
import { ApplicationService } from '../application.service';
import { RecommendedAndOtherEMIPlans } from '../application';
import { LoginService } from '../../login/login.service';
import { TokenService } from '../../token/token.service';
import { LoaderService, Loader } from '../../common/loader/loader.service';
import { AwsTrackingService } from '../../common/tracking/aws-tracking.service';
import { EventDetails } from 'app/common/tracking/aws-tracker';

@Injectable()
export class EmiResolveService implements Resolve<RecommendedAndOtherEMIPlans> {

  constructor(private applicationService: ApplicationService, private loaderService: LoaderService, private awsTrackingService: AwsTrackingService, private loginService: LoginService, private tokenService: TokenService) { }
  resolve(route: ActivatedRouteSnapshot): any {
    const affiliate = this.tokenService.getAffiliateCampaign();
    const referrer = this.tokenService.getDocumentReferrer();
    const skipDashboard = this.tokenService.getSkipDashboard();
    this.tokenService.removeAll(false);
    if (affiliate) {
      this.tokenService.setAffiliateCampaign(affiliate);
    }
    if (referrer) {
      this.tokenService.setDocumentReferrer(referrer);
    }
    if (skipDashboard) {
      this.tokenService.setSkipDashboard(true);
    }
    if (route.queryParams.utm_source) {
      this.tokenService.updateAndSetGlobalParams('Utm_Source', route.queryParams.utm_source);
    }
    if (route.queryParams.utm_medium) {
      this.tokenService.updateAndSetGlobalParams('Utm_Medium', route.queryParams.utm_medium);
    }
    if (route.queryParams.utm_campaign) {
      this.tokenService.updateAndSetGlobalParams('Utm_Campaign', route.queryParams.utm_campaign);
    }
    this.awsTrackingService.generateAndUpdateUUID();
    if (route.queryParams.LoanApplicationId) {
      return this.applicationService.getRecommendedAndOtherEMIPlans(route.queryParams.merchantid, route.queryParams.basketamount, route.queryParams.downpaymentamount, route.queryParams.paymentGatewayId);
    } else {
      const event = new EventDetails('EMI-Page-Skipped', 'page', 'noId');
      this.awsTrackingService.sendDataToFunnel(event).subscribe();
      this.loaderService.ShowLoaderSource.next(new Loader(true, ''));
      if (route.queryParams.signup) {
        this.loginService.goToLoginUrl(true);
      } else {
        this.loginService.goToLoginUrl(false);
      }
    }
  }
}
